

























































import Vue from 'vue'
import { ICategoryActive, ICategoryNode } from '@/interfaces/info'
import { mapGetters } from 'vuex'

interface IBreadcrumbItem {
  text: string;
  to: string
}

export default Vue.extend({
  name: 'CategoryListBar',
  data () {
    return {
      activeCategory: null as string | null,
      activeSubCategory: null as string | null,
      activeProduct: null as string | null
    }
  },
  computed: {
    category (): string | (string | null)[] {
      return this.$route.query.category
    },
    ...mapGetters({ categoryList: 'info/categoryList', categoryTree: 'info/categoryTree' })
  },
  watch: {
    categoryTree (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initializeCategoryList()
      }
    },
    category (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initializeCategoryList()
      }
    }
  },
  created () {
    this.initializeCategoryList()
  },
  methods: {
    initializeCategoryList () {
      const inheritedActiveState = this.$store.getters['info/active'] as ICategoryActive
      this.activeCategory = inheritedActiveState.activeCategory
      this.activeSubCategory = inheritedActiveState.activeSubCategory
      if (this.$route.name !== 'Home') { this.activeProduct = inheritedActiveState.activeProduct }

      let id = '0'
      if (this.$route.name === 'Home') {
        id = this.$route.query.category as string
        // Has sub category
        if (this.$route.query.parent !== undefined) {
          this.updateActiveCategoryByCategoryId(this.$route.query.parent as string)
          this.updateActiveSubCategory(id)
        } else {
          this.updateActiveCategoryByCategoryId(id)
        }
      } else if (this.$route.name === 'Product') {
        const categoryRoute = this.$store.getters['info/categoryRouteHistory']

        id = this.$route.params.productId
        if (categoryRoute.length === 2) {
          this.updateActiveCategoryByCategoryId(categoryRoute[0])
          if (categoryRoute[1] !== undefined) {
            this.updateActiveSubCategory(categoryRoute[1])
          }
          const foundCategoryId = this.findActiveProductIdInCategory(categoryRoute[0], id)
          if (foundCategoryId !== null) {
            this.updateActiveProduct(id)
          }
        } else {
          this.updateActiveCategoryByProductId(id)
          this.updateActiveProduct(id)
        }
      }
      // Do not commit state change if is from home page, since we have set it
      if (this.$store.getters.from !== 'Home') { this.commitActiveState() }
    },
    getActiveCategoryByProductId (id: number | string) {
      // undefined
      id = id || 0
      for (const categoryNode of (this.categoryTree as ICategoryNode[])) {
        for (const child of categoryNode.childList) {
          if (child.id === id.toString()) {
            return categoryNode.categoryId
          }
        }
      }

      return null
    },
    findActiveProductIdInCategory (categoryId: number | string, productId: number | string) {
      categoryId = categoryId || 0
      if (this.$route.name === 'Product') {
        for (const categoryNode of (this.categoryTree as ICategoryNode[])) {
          if (categoryNode.categoryId.toString() === categoryId.toString()) {
            for (const child of categoryNode.childList) {
              if (child.id === productId.toString()) {
                return categoryNode.categoryId.toString()
              }
            }
            return null
          }
        }
      }
      return null
    },
    updateActiveCategoryByProductId (id: number | string) {
      const foundCategoryId = this.getActiveCategoryByProductId(id)
      if (foundCategoryId !== null) {
        this.updateActiveCategoryByCategoryId(foundCategoryId)
      }
    },
    updateActiveCategoryByCategoryId (id: number | string) {
      id = id || 0
      this.activeCategory = id.toString()
    },
    updateActiveSubCategory (id: number | string) {
      this.activeSubCategory = id.toString()
    },
    updateActiveProduct (id: number | string) {
      this.activeProduct = id.toString()
    },
    onCategoryItemClicked (categoryId: number) {
      // Inactive sub category and product classes
      this.activeSubCategory = null
      this.activeProduct = null
      this.updateActiveCategoryByCategoryId(categoryId)
      this.commitActiveState()

      if (categoryId === 0) {
        if (this.$route.name === 'Home' && (this.$route.query.category === undefined || this.$route.query.category === '0')) {
          this.$emit('loadData')
        }
      } else {
        if (this.$route.query.category === categoryId.toString()) {
          this.$emit('loadData')
        }
      }
    },
    onSubCategoryItemClicked (parentCategoryId: number, childCategoryId: number) {
      // Inactive product class
      this.activeProduct = null

      this.updateActiveCategoryByCategoryId(parentCategoryId)
      this.updateActiveSubCategory(childCategoryId)
      this.commitActiveState()

      if (this.$route.name === 'Home') {
        if ((this.$route.query.category as string) === childCategoryId.toString()) {
          this.$emit('loadData')
        }
      }
    },
    onProductListItemClicked (categoryId: number, productId: number) {
      // Inactive subCategory class
      this.activeSubCategory = null

      this.updateActiveCategoryByProductId(productId)
      this.updateActiveProduct(productId)
      this.commitActiveState()

      this.setActiveRouteHistory(categoryId, undefined)
      if (this.$route.params.productId === productId.toString()) {
        this.$emit('loadData')
      }
    },
    setActiveRouteHistory (categoryId: number | undefined, subCategoryId: number | undefined) {
      this.$store.commit('info/SET_ROUTE_HISTORY', [categoryId ? categoryId.toString() : undefined, subCategoryId ? subCategoryId.toString() : undefined])
    },
    commitActiveState () {
      this.$store.commit('info/SET_ACTIVE', {
        activeCategory: this.activeCategory,
        activeSubCategory: this.activeSubCategory,
        activeProduct: this.activeProduct
      })
    }
  }
})
